import store from '@/store/store';
const excludedRoutes = [
  'dashboard',
  'login',
  'logout',
];

const hasAccessPersonas = async (params = {}) => {
  // Users which have a System persona OR have a Personas privilege through their Role's Persona
  // can access and edit all personas

  if (store.getters['personas/isSystem']) {
    return true;
  }

  const slug = params.name.split('.');
  let action = '';
  let route = '';

  if (slug.length === 1) {
    action = 'View';
    route = slug[0];
  } else {
    const actionSlug = slug[slug.length - 1];
    action = actionSlug[0].toUpperCase() + actionSlug.substring(1);
    slug.pop();
    route = slug.join('_')
  }

  const privileges = store.getters['personas/privileges'];
  const hasAccess = privileges.find((navAccessItem) => navAccessItem.PageName === 'personas');

  return (hasAccess && hasAccess[action] && Number(hasAccess[action]));
}

const hasAccess = async (params = {}) => {
  const slug = params.name.split('.');
  let action = '';
  let route = '';

  if (slug.length === 1) {
    action = 'View';
    route = slug[0];
  } else {
    const actionSlug = slug[slug.length - 1];
    action = actionSlug[0].toUpperCase() + actionSlug.substring(1);
    slug.pop();
    route = slug.join('_')
  }

  if (route.includes('personas')) {
    return store.getters['personas/isSystem'];
  }

  const privileges = store.getters['personas/privileges'];
  const hasAccess = privileges.find((navAccessItem) => navAccessItem.PageName === route);

  return (hasAccess && hasAccess[action] && Number(hasAccess[action]));
}

export const canAccess = async (params = {}) => {
  if (excludedRoutes.includes(params.name)) {
    return true;
  }

  if (params.name.includes('personas')) {
    return await hasAccessPersonas(params);
  }

  return await hasAccess(params);
}
